import { Status } from "lavva.exalushome/build/js/DataFrame";
import { IntRange } from "lavva.exalushome/build/js/Helpers";
import { ResponseResult } from "lavva.exalushome/build/js/Services/FieldChangeResult";
import { FacadeConfigurationErrorCode } from "./ZfBidiConfigService";

export type LamelaTiltCalibration = {
    InitCalibrationAsync: () => Promise<ResponseResult<FacadeConfigurationErrorCode> | Status>;
    LamelaManualCalibration: LamelaManualCalibration;
    ConfirmFirstPositionAsync: () => Promise<Status>;
    ConfirmSecondPositionAsync: () => Promise<Status>;
    EndCalibrationAsync: () => Promise<Status>;
}

export type LamelaManualCalibration = {
    MoveOneStepUpAsync: () => Promise<Status>;
    MoveOneStepDownAsync: () => Promise<Status>;
}

/**
 * Facade blind lock time in minutes
 */
export type FacadeLockTime = IntRange<0, 256>;

export class CalibrationStatusData {
    CalibrationProgress: CalibrationProgress = CalibrationProgress.Disabled;
    TravelTimeCalibration: boolean = false;
    LamellaTiltCalibration: boolean = false;
    IsCurrentPositionKnown: boolean = false;
}

export enum CalibrationProgress {
    Disabled = 0,
    MovementTimeCalibration = 1,
    LamellaTiltCalibration = 2
}

export class PairedWindSensor {
    IsPaired: boolean = false;
    SensorSeriallId: string = "";
}

export enum FacadeDetection {
    Automatic = 0,
    ForceType90 = 1,
    ForceType180 = 2
}